import { render } from "./AdminSubscribers.vue?vue&type=template&id=3ca7635e"
import script from "./AdminSubscribers.vue?vue&type=script&lang=js"
export * from "./AdminSubscribers.vue?vue&type=script&lang=js"

import "./AdminSubscribers.vue?vue&type=style&index=0&id=3ca7635e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__